import { GameState } from '../types/types';
import { GetStatisticsResponse } from './api';

const GAME_KEY = (dateString: string) => `wormle-game:${dateString}`;
const STATS_KEY = (dateString: string) => `wormle-stats:${dateString}`;

export interface SavedGame {
  gameDate: string;
  gameState: GameState;
  startDate: number;
}

export interface SavedStats {
  gameDate: string;
  postStatisticResponse: GetStatisticsResponse;
  secondsToComplete: number;
  hintsUsed: number;
}

// --- GAME PERSISTENCE ---
export function saveGameToLocalStorage(
  gameDate: string,
  gameState: GameState,
  startDate: number,
) {
  const savedGame: SavedGame = { gameDate, gameState, startDate };
  localStorage.setItem(GAME_KEY(gameDate), JSON.stringify(savedGame));
}

export function loadGameFromLocalStorage(dateString: string): SavedGame | null {
  const data = localStorage.getItem(GAME_KEY(dateString));
  return data ? (JSON.parse(data) as SavedGame) : null;
}

// --- STATISTICS PERSISTENCE ---
export function saveStatsToLocalStorage(
  gameDate: string,
  postStatisticResponse: GetStatisticsResponse,
  secondsToComplete: number,
  hintsUsed: number,
) {
  const savedStats: SavedStats = {
    gameDate,
    postStatisticResponse,
    secondsToComplete,
    hintsUsed,
  };
  localStorage.setItem(STATS_KEY(gameDate), JSON.stringify(savedStats));
}

export function loadStatsFromLocalStorage(gameDate: string): SavedStats | null {
  const data = localStorage.getItem(STATS_KEY(gameDate));
  return data ? (JSON.parse(data) as SavedStats) : null;
}
